



































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class RewritingLevelPopup extends Vue {
  @Prop({ default: {} })
  level: any;
  @Prop({ default: true })
  visible: boolean;
  @Watch('visible')
  listenVisible(val) {
    this.show = val
    if (val && this.level && this.level.id) {
      this.activeLevel = this.level;
    }
  }

  show = false;
  activeLevel: any = {}; // 选中的改写程度
  levelList = [
    {
      id: 'mild',
      title: '轻度改写',
      default: true,
      desc: '不改变原文的意思和表达顺序',
    }, {
      id: 'moderate',
      title: '中度改写',
      desc: '不改变原文的意思，但表达顺序会有所变化',
    }, {
      id: 'abbr',
      title: '缩写',
      desc: '保持原文意思不变，并缩写到指定字数',
    },
  ];
  doSelectLevel(item) {
    this.activeLevel = item;
  }

  /** 缩写字数操作 */
  activeAbbrWords: any = {}; // 选中的缩写字数
  abbrWordsList = [
    {
      value: 'keep',
      name: '保持现有字数',
      default: true,
    }, {
      value: '800',
      name: '800字左右',
    }, {
      value: '1000',
      name: '1000字左右',
    }, {
      value: '2000',
      name: '2000字左右',
    }, {
      value: 'custom',
      name: '',
      length: 0,
    }
  ]
  doSelectCount(count) {
    this.activeAbbrWords = count;
    if (this.activeLevel.id !== 'abbr') {
      this.activeLevel = this.levelList.find(item => item.id === 'abbr');
    }
    if (count.value === 'custom') {
      this.showCustomLength();
    }
  }
  isCustomAbbrWordsVisible = false;
  showCustomLength() {
    this.isCustomAbbrWordsVisible = true;
    this.$nextTick(() => {
      (this.$refs.customInput as any).focus();
    })
  }
  customLength = '';
  doConfirmCustomLength() {
    if (!this.customLength) return this.$toast({
      message: '请输入缩写字数',
      duration: 3000
    })
    this.isCustomAbbrWordsVisible = false;
    const customAbbrWords = this.abbrWordsList.find(item => item.value === 'custom');
    customAbbrWords.length = +this.customLength;
    customAbbrWords.name = this.customLength + '字左右';
  }

  mounted() {
    this.activeLevel = this.levelList.find(item => item.default) || {};
    this.activeAbbrWords = this.abbrWordsList.find(item => item.default) || {};
    this.$emit('change-level', this.activeLevel);
  }
  closePopup() {
    this.$emit('close');
  }
  doConfirm() {
    if (this.isCustomAbbrWordsVisible) {
      this.doConfirmCustomLength();
      return;
    }
    this.closePopup();
    this.$emit('change-level', this.activeLevel);
  }
}
